import { mapSiteIdToName } from '@/helpers/utils/siteUtils';
import { CUSTOMER_DETAILS_HEADER_KEYS } from '../../customer-detail/constants';

export const transformSuggestedAddress = (data: any) => {
  const customerData = [
    { field: CUSTOMER_DETAILS_HEADER_KEYS.ACCOUNT_NUMBER, value: data?.customerId, mask: true },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.FIRST_NAME,
      value: data?.CustomerInfo?.firstName,
      key: 'firstName',
      mask: true,
    },
    { field: CUSTOMER_DETAILS_HEADER_KEYS.LAST_NAME, value: data?.CustomerInfo?.lastName, key: 'lastName', mask: true },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.COMPANY_NAME,
      value: data?.CustomerInfo?.companyName,
      key: 'companyName',
      mask: true,
    },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.PHONE_NUMBER,
      value: data?.DivisionCustomers?.length > 0 ? data?.DivisionCustomers?.[0]?.PhoneRecords : [],
      key: 'phoneNumber',
      mask: true,
    },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.EMAIL_ADDRESS,
      value: data?.DivisionCustomers?.length > 0 ? data?.DivisionCustomers?.[0]?.EmailRecords : [],
      key: 'email',
      mask: true,
    },
  ];
  const customerAddress = [
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.STREET_NAME,
      value: data?.BillingAddress?.LocationInfo?.line1 ?? '',
      key: 'streetName',
      mask: true,
    },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.ADDITIONAL_ADDRESS,
      value: data?.BillingAddress?.LocationInfo?.line2 ?? '',
      key: 'additionalAddressInfo',
      mask: true,
    },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.CITY,
      value: data?.BillingAddress?.LocationInfo?.city ?? '',
      key: 'city',
      mask: true,
    },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.STATE,
      value: data?.BillingAddress?.LocationInfo?.state ?? '',
      key: 'state',
      mask: true,
    },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.ZIP_CODE,
      value: data?.BillingAddress?.LocationInfo?.zip ?? '',
      key: 'postalCode',
      mask: true,
    },
    {
      field: CUSTOMER_DETAILS_HEADER_KEYS.DIVISIONS,
      value: mapSiteIdToName(data?.CustomerInfo?.AffiliatedDivisions ?? []) ?? '',
      key: 'divisions',
    },
  ];

  return { customerData, customerAddress };
};
